import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import {
  ensureHexColor,
  getRgbColorFromHex,
  isLightColor,
} from '@sorare/core/src/lib/colors';

import type { useCardCollectionData_cardCollection } from './__generated__/useCardCollectionData.graphql.ts';

export const useCardCollectionData = (
  cardCollection: useCardCollectionData_cardCollection
) => {
  const { team, sportSeason } = cardCollection;

  const { styleGuideColor } = team || {};
  const { startYear, endYear, singleCivilYear } = sportSeason || {};

  const displayedStartYear = singleCivilYear
    ? startYear
    : startYear && startYear % 2000;
  const displayedEndYear = !singleCivilYear && endYear ? endYear % 2000 : null;

  const hexColor = ensureHexColor(styleGuideColor);

  const rgbColor =
    hexColor && !isLightColor(hexColor) ? getRgbColorFromHex(hexColor) : null;

  const backgroundColor =
    hexColor && !isLightColor(hexColor) ? hexColor : 'var(--c-nl-700-opaque)';

  return {
    displayedStartYear,
    displayedEndYear,
    hexColor,
    rgbColor,
    backgroundColor,
  };
};

useCardCollectionData.fragments = {
  cardCollection: gql`
    fragment useCardCollectionData_cardCollection on CardCollection {
      slug
      team: anyTeam {
        slug
        styleGuideColor
      }
      sportSeason {
        name
        startYear
        endYear
        singleCivilYear
      }
    }
  ` as TypedDocumentNode<useCardCollectionData_cardCollection>,
};
